import React, { useEffect, useRef, useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import image from '../../assets/image.png';
import senddata from "../../Data/data.js";
import sendFormData from "../../Data/formData.js";
import { useNavigate } from 'react-router-dom';

function Courses() {

  const navigate = useNavigate();

  const fileInputRef = useRef(null);
;
  const [allCourses,setAllCourses]=useState();
  const [refresh,setRefresh]=useState(false);
  const [openAddQ,setOpenAddQ]=useState(false);

  const [title,setTitle]=useState("");
  const [price,setPrice]=useState("");
  const [subject,setSubject]=useState("");
  const [level,setLevel]=useState("one");
  const [departement,setDepartement]=useState("sec");
  const [file,setFile]=useState("");

  const [selectedImage,setSelectedImage]=useState("");

  const [selectLevel,setSelectLevel] = useState("one-pre");


  useEffect(()=>{
    if(selectLevel=="six-pri"){
      setLevel("six")
      setDepartement("pri");
    } else if(selectLevel=="one-pre"){
      setLevel("one")
      setDepartement("pre");
    } if(selectLevel=="two-pre"){
      setLevel("two")
      setDepartement("pre");
    } if(selectLevel=="three-pre"){
      setLevel("three")
      setDepartement("pre");
    } if(selectLevel=="one-sec"){
      setLevel("one")
      setDepartement("sec");
    } if(selectLevel=="two-sec"){
      setLevel("two")
      setDepartement("sec");
    } if(selectLevel=="three-sec"){
      setLevel("three")
      setDepartement("sec");
    }
  },[selectLevel])


  useEffect(()=>{
    getAllCourses();
  },[refresh])

  const getAllCourses =() =>{
    senddata("course/getmycourses",{}, "GET").then((res) => {
      if (res.status !== 200) {
      alert('تأكد من الاتصال من الانترنت ');
      } else {
        console.log(res.data);
        setAllCourses(res.data);
      }
      });
  }

  const handleFileChange = (e) => {
    const newfile = e.target.files[0];
    if (newfile) {
        const validImageTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
        if (!validImageTypes.includes(newfile.type)) {
          alert("ادخل صورة ")
          return;
      }
        setFile(newfile)
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result); 
        };
        reader.readAsDataURL(newfile); 
    }else {
      setSelectedImage(""); 
      setFile("");
    }
  };

  const addCourse =() =>{
    let data = new FormData();
    data.append('title', title);
    data.append('subject', subject);
    data.append('price', price);
    data.append('level', level);
    data.append('departement', departement);
    data.append('file',file );

    console.log("data",title,subject,price,level,departement,file)

    sendFormData("course/createcourse",data, "Post").then((res) => {
      if (res.status !== 200) {
        alert('ادخل بيانات صحيحة');
      } else {
        alert('تم اضافة الكورس بنجاح ');
        setTitle("");
        setSubject("");
        setPrice("");
        setRefresh(!refresh);
      }
      });
  }

  const deleteCourse =(id) =>{
    const userResponse = prompt(`اكتب ok لتأكيد حذف الكورس `);

    if(userResponse?.trim() =="ok" ){
    senddata(`course/deletecourse/${id}`,{}, "DELETE").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال بالانترنت');
      } else {
        alert('تم مسح الكورس بنجاح ');
        setRefresh(!refresh);
      }
      });
    }else {
        alert("لم يتم حذف الكورس");
        setRefresh(!refresh)
    }
  }

  const editCourse =(course) =>{
    navigate("/course",{ state: course });
  }

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
      <div className='headers  '>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      {/* add */}
      <div className='add_student p-5 w-screen xl:w-[80%] xl:ml-[10%] text-right flex flex-col justify-end '>
          <p onClick={()=>{setOpenAddQ(!openAddQ)}} className='px-10 py-2 mb-4 bg-[#e9ad03] w-fit rounded-full cursor-pointer'>{openAddQ?"اخفاء الاضافة":"اضافة كورس"}</p> 
          {openAddQ&&
          <div>
            <div className=' grid grid-cols-1 rever gap-4'>
              <img src={selectedImage} className='w-full mb-4 lg:w-[60%] lg:ml-[20%]' />
            </div>
            <div className=' grid grid-cols-2 rever gap-4'>
              <input 
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='التصنيف'
                />
              <input 
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='الكورس'
                />
            </div>

            <div className=' grid grid-cols-2 rever gap-4'>
              <input 
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='السعر'
              />
              <select value={selectLevel} onChange={(event)=>{setSelectLevel(event.target.value);}} className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right ">
                  <option value="six-pri" className=' text-black'>ستة ابتدائي</option>
                  <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                  <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                  <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                  <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                  <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                  <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
              </select>
          </div>
            <div className=' grid grid-cols-2 rever gap-4'>
              <p onClick={addCourse} className='px-6 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6'>اضافة كورس</p> 
              <div className='h-full flex items-end justify-end' >
                <p onClick={()=>{setFile("");setSelectedImage("");}} className='mr-4 text-2xl cursor-pointer'>🗑️</p>
                <img src={image} className='w-12 rounded-full mt-auto lg:mr-5 cursor-pointer' onClick={()=>{fileInputRef.current.click()}} />
              </div>
              <input 
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                className="hidden"
                />
            </div>
          </div>
          }
      </div>
      {/* display courses */}
      <h2 className=' text-right mr-4 '>: الكورسات  </h2>
          {allCourses?.length && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 min-h-screen '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[150px] text-center'>الكورس</div>
                  <div className='text-base w-[150px] text-center'> المادة</div>
                  <div className='text-base w-[100px] text-center'>السنة الدراسية</div>
                  <div className='text-base w-[100px] text-center'> المرحلة</div>
                  <div className='text-base w-[100px] text-center'>  السعر</div>
                  <div className='text-base w-[150px] text-center'>المدرس</div>
                  <div className='text-base w-[100px] text-center'>تعديل</div>
                  <div className='text-base w-[100px] text-center'>مسح</div>
                </div>
              {allCourses?.map((course) => (
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={course._id}> 
                  <div className='text-base w-[150px] text-center'> {course.title}</div>
                  <div className='text-base w-[150px] text-center'>{course.subject}</div>
                  <div className='text-base w-[100px] text-center'>{course.level}</div>
                  <div className='text-base w-[100px] text-center'>{course.departement}</div>
                  <div className='text-base w-[100px] text-center'>{course.price}</div>
                  <div className='text-base w-[150px] text-center'>{"Mr " +course.Teachername}</div>
                  <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{editCourse(course)}} className='  w-fit rounded-full cursor-pointer'>📝</p> </div>
                  <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{deleteCourse(course._id)}} className='  w-fit rounded-full cursor-pointer'>🗑️</p> </div>
                </div>
              ))}
              </div>
          )}


      
    </div>
  )
}

export default Courses
